import { ALLOW_EDIT } from '../../../utils/OperationPermissions';

const CustomerPriceReview = {
  type: 'CustomerPriceReviewMutationInput',
  title: 'Customer Price Review',
  formTitle: 'Customer Price Review',
  formUrl: '/Customers/CustomerPriceReview/',
  screenReference: 'CUSTOMER_PRICE_REVIEW',
  operations: ALLOW_EDIT,
  returnUrl: '/menu/Customers',
};

export default CustomerPriceReview;
